jQuery(document).ready(function ($) {
    $('.accordion-content .card .card-header').on('click', function () {
        let card_body = $(this).siblings('.card-body');
        let card_show = card_body.hasClass('show');
        let icon_collapse = $(this).find('.icon-collapse');
        let acordion = $('.accordion-content');

        acordion.find('.card-body').removeClass('show');
        acordion.find('.icon-collapse').removeClass('show');
        if (!card_show) {
            icon_collapse.addClass('show')
            card_body.addClass('show');
        }
    });
});